module.exports = __webpack_public_path__ + "img/desktop.ffb3d1e7.jpg";